import { useState } from "react";
import { useForm } from "react-hook-form";
import useFetchWrapper from "../../Helpers/useFetchWrapper";
import { Props, RenewalStatus } from "./MentorRenewalPopup.model";

export const useMentorRenewalPopup = ({ onClose, user }: Props) => {
	const [status, setStatus] = useState<RenewalStatus | undefined>();
	const [step, setStep] = useState<1 | 2 | 3>(1);
	

	const { put } = useFetchWrapper();

	const { control, handleSubmit, formState: { errors } } = useForm({
		defaultValues: { message: '' }
	})

	
	const approveRenewal = async (data: any) => {
		const message = data.message ? { message: data.message } : {};
		const response = await put(`/user/downgrade/renew/${user.userId}`, message);
		if (response.status === 200) setStep(3);
	}

	const rejectRenewal = async (data: any) => {

		const response = await put(`/user/downgrade/demote/${user.userId}`, data.message);
		if (response.status === 200) setStep(3);
	}


	return {
		approveRenewal,
		control,
		handleSubmit,
		rejectRenewal,
		setStatus,
		setStep,
		state: {
			errors,
			status,
			step
		}
	}	
}